/**
 * ALT-SCHEDULE-POSTPURCHASE-001
 * Progressive enhancement only — the form is a native {% form 'contact' %} and must
 * submit correctly with this script absent. Handles:
 *  - the schedule-mode toggle (fill in details vs. just call me)
 *  - reading ?order= from the URL to pre-fill/confirm the order number
 *  - reading ?zip=/?coverage= from the URL and writing the silent Coverage Flag field
 *    (see service-coverage.md "Automated ZIP Triage" — never shown to the customer)
 */
(function () {
  var form = document.getElementById('ScheduleVisitForm');
  if (!form) return;

  var params = new URLSearchParams(window.location.search);

  // --- Order number: confirm from URL if present, else leave the manual field as-is ---
  var orderParam = params.get('order');
  if (orderParam) {
    var orderValueEl = form.querySelector('[data-order-value]') || document.querySelector('[data-order-value]');
    var confirmedText = document.querySelector('[data-order-confirmed-text]');
    var manualText = document.querySelector('[data-order-manual-text]');
    var orderInput = form.querySelector('[data-order-input]');

    if (orderValueEl) orderValueEl.textContent = String(orderParam).replace(/^#/, '');
    if (confirmedText) confirmedText.hidden = false;
    if (manualText) manualText.hidden = true;
    if (orderInput) orderInput.value = orderParam;
  }

  // --- Coverage triage flag: silent, never rendered as visible copy ---
  var coverageParam = params.get('coverage');
  var zipParam = params.get('zip');
  var coverageField = form.querySelector('[data-coverage-field]');
  if (coverageField) {
    if (coverageParam) {
      coverageField.value = zipParam ? coverageParam + ' (ZIP ' + zipParam + ')' : coverageParam;
    } else {
      coverageField.value = '';
    }
  }

  // --- Schedule-mode toggle ---
  var modeChoice = form.querySelector('[data-schedule-mode-choice]');
  var detailFields = form.querySelector('[data-schedule-detail-fields]');
  var submitButton = form.querySelector('[data-schedule-submit]');

  if (modeChoice && detailFields && submitButton) {
    var radios = modeChoice.querySelectorAll('input[data-schedule-mode]');
    var setMode = function (mode) {
      if (mode === 'call') {
        detailFields.hidden = true;
        submitButton.textContent = "Have José Luis's team call me";
      } else {
        detailFields.hidden = false;
        submitButton.textContent = 'Request my visit';
      }
    };

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        setMode(radio.dataset.scheduleMode);
      });
    });
  }
})();
